import { render, staticRenderFns } from "./ConsultorioConfig.vue?vue&type=template&id=22a4d892&"
import script from "./ConsultorioConfig.vue?vue&type=script&lang=js&"
export * from "./ConsultorioConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports